import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Asset } from '../models/asset';
import { assets } from '../palette/palette';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SessionStorage } from 'ngx-webstorage';
import { PaletteComponent } from '../../editor/palette/palette.component';


@Injectable()
export class PaletteService {

    @SessionStorage('auth.Engine.token')
    public engineToken;


    constructor(private readonly http: HttpClient) { }

    dragStartedEventEmitter = new EventEmitter<Event>();
    dragEndedEventEmitter = new EventEmitter<Event>();

    getAssets(url: string, keyJWT: string): Observable<Asset[]> {
        return of(assets);
    }

    getWizardAssets(): Observable<Asset[]> {
        return of(assets);
    }

    getLibelle(type: string): string {
        let label: string;
        switch (true) {
            case type.includes('COMBO_BOX'):
                label = 'Label de liste';
                break;
            case type.includes('RADIO_LIST_HORIZONTAL'):
                label = 'Label de liste de choix horizontale';
                break;
            case type.includes('RADIO_LIST_VERTICAL'):
                label = 'Label de liste de choix verticale';
                break;
            case type.includes('RADIO_BUTTON'):
                label = 'Label de choix';
                break;
            case type.includes('HEADER'):
                label = 'Label de titre';
                break;
            case type.includes('MESSAGE'):
                label = 'Label de message';
                break;
            case type.includes('TEXT'):
                label = 'Label de texte';
                break;
            case type.includes('INTEGER'):
                label = 'Label d\'entier';
                break;
            case type.includes('CHECK_BOX'):
                label = 'Label de choix';
                break;
            case type.includes('DATE'):
                label = 'Label de date';
                break;
            case type.includes('CONTAINER'):
                label = 'Label de groupe';
                break;
            default:
                label = 'Label';
        }
        return label;
    }


    getCustomPalette(url: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': this.engineToken,
            })
        };
        return this.http.get(`${url}/eazly-api/v1/custom-palette`, httpOptions);
    }
    getAssetDataTypeByElementType(elementType: string): string {
        let dataType = "";
        const advancedAssets = PaletteComponent.getAdvancedPalette();
        advancedAssets.forEach((asset) => {
            if (asset.id === elementType) {
                dataType = asset.dataType;
            }
        })
        return dataType;
    }

    getAssetNameByElementType(elementType: string): string {
        let name = "";
        const advancedAssets = PaletteComponent.getAdvancedPalette();
        advancedAssets.forEach((asset) => {
            if (asset.id === elementType) {
                name = asset.name;
            }
        })
        return name;
    }
}
